<template>
<div>
<div v-if="this.returnAccount!=-1">
          <v-list>
          <v-list-item class="px-2">
            <v-list-item-avatar style="width:60px;height:60px;">
              <v-img :src="'https://ndxfacegen.azurewebsites.net/home/ImageGenByName/'+this.returnAccount.yourName"></v-img>
            </v-list-item-avatar>
          </v-list-item>

          <v-list-item link>
            <v-list-item-content>
              <v-list-item-title class="title">
                {{this.returnAccount.yourName}}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{this.returnAccount.email}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
           <v-menu v-if="this.returnAccount.businesses.length>1" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-chip
        class="ml-5 mb-5"
          outlined
          v-on="on"
        >
          Dropdown
        </v-chip>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in this.returnAccount.businesses"
          :key="index"
          @click="selectBusiness(item.businessID)"
        >
          <v-list-item-title>{{ item.businessName }}

<v-icon v-if="item.owner">mdi-crown</v-icon>

          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
      

        </div>
  
            <div v-else class="pa-5">
              <v-skeleton-loader
       
        class="mb-5"
          type="avatar"
        ></v-skeleton-loader>
        <v-skeleton-loader class="mb-1"
        
          type="heading"
        ></v-skeleton-loader>     <v-skeleton-loader
    
          type="text@1"
        ></v-skeleton-loader>
        </div>
            </div>
</template>

<script>

    import {mapActions, mapGetters, mapMutations} from 'vuex';

    export default {
         computed:{
      ...mapGetters(["returnAccount", "returnUserLoaded"]),
    },
  created: function () {
    // `this` points to the vm instance
    if(this.returnAccount==-1){
        this.loadAccount();
    }
 
  },

    methods: {
    ...mapActions(["loadAccount","loadClients"]),
    ...mapMutations(["setBusinessId"]),
  selectBusiness:function(i){
    this.setBusinessId(i);
    this.loadClients();
  },

  },

    }
</script>

<style>

</style>
<style lang="scss" scoped>

</style>